(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["d1-depth-motion"] && !Shopify.designMode) return;
  try {
    function d1DepthInit(root=document){
  root.querySelectorAll('[data-d1-depth]').forEach(section=>{
    if(section.dataset.depthReady)return;
    section.dataset.depthReady='true';
    const enabled=matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
    const controller=new AbortController();
    const cards=[...section.querySelectorAll('.d1-category,.d1-card-photo,.d1-spotlight-photo')];
    const resets=[];
    cards.forEach(card=>{
      let frame=0,x=0,y=0;
      const reset=()=>{cancelAnimationFrame(frame);frame=0;card.classList.remove('d1-depth-active');['--d1-rx','--d1-ry','--d1-px','--d1-py'].forEach(key=>card.style.removeProperty(key))};
      resets.push(reset);
      card.addEventListener('pointermove',event=>{
        if(!enabled.matches||event.pointerType!=='mouse')return;
        const rect=card.getBoundingClientRect();
        x=Math.max(0,Math.min(1,(event.clientX-rect.left)/rect.width));
        y=Math.max(0,Math.min(1,(event.clientY-rect.top)/rect.height));
        if(frame)return;
        frame=requestAnimationFrame(()=>{frame=0;card.style.setProperty('--d1-rx',`${(0.5-y)*5}deg`);card.style.setProperty('--d1-ry',`${(x-0.5)*5}deg`);card.style.setProperty('--d1-px',`${x*100}%`);card.style.setProperty('--d1-py',`${y*100}%`);card.classList.add('d1-depth-active')});
      },{passive:true,signal:controller.signal});
      card.addEventListener('pointerleave',reset,{signal:controller.signal});
      card.addEventListener('pointercancel',reset,{signal:controller.signal});
      card.addEventListener('blur',reset,{signal:controller.signal});
    });
    const clear=()=>resets.forEach(reset=>reset());
    enabled.addEventListener('change',clear,{signal:controller.signal});
    document.addEventListener('visibilitychange',clear,{signal:controller.signal});
    window.addEventListener('scroll',clear,{passive:true,signal:controller.signal});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(section)){clear();controller.abort()}},{signal:controller.signal});
  });
}
d1DepthInit();
document.addEventListener('shopify:section:load',event=>d1DepthInit(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d1-midstory"] && !Shopify.designMode) return;
  try {
    if('IntersectionObserver'in window){const d1MiddleObserver=new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.classList.toggle('is-in-view',entry.isIntersecting)),{threshold:.15});document.querySelectorAll('.d1-midstory').forEach(el=>d1MiddleObserver.observe(el))}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d1-motion"] && !Shopify.designMode) return;
  try {
    function d1Motion(root=document){if(!('IntersectionObserver'in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.animate([{transform:'translateY(18px)',opacity:.65},{transform:'translateY(0)',opacity:1}],{duration:550,easing:'cubic-bezier(.2,.6,.3,1)'});observer.unobserve(entry.target)})},{threshold:.12});root.querySelectorAll('.d1-section-head,.d1-category,.d1-spotlight,.d1-articles article').forEach(el=>{if(el.dataset.motionReady)return;el.dataset.motionReady='true';observer.observe(el)})}d1Motion();document.addEventListener('shopify:section:load',event=>d1Motion(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["d1-product-reviews"] && !Shopify.designMode) return;
  try {
    function d1ReviewPanels(root=document){root.querySelectorAll('[data-d1-product-reviews]').forEach(panel=>{if(panel.dataset.ready)return;panel.dataset.ready='1';const loox=panel.querySelector('#looxReviews'),opinew=panel.querySelector('#opinew_product_plugin_app'),partial=panel.querySelector('.d1-review-partial'),unavailable=panel.querySelector('.d1-review-unavailable');let elapsed=false,frame=0;const visible=el=>el.getBoundingClientRect().height>25&&getComputedStyle(el).display!=='none';function check(){frame=0;if(!elapsed)return;const saved=loox.querySelector('#loox-inline-reviews');const looxReady=[...loox.children].some(el=>el!==saved&&el.tagName!=='SCRIPT'&&el.tagName!=='STYLE'&&visible(el));const opinewReady=Boolean(opinew&&(opinew.textContent.trim()||opinew.querySelector('iframe'))&&visible(opinew));const fallback=Boolean(saved&&saved.textContent.trim()&&!looxReady);panel.classList.toggle('is-text-fallback',fallback);partial.hidden=!fallback;unavailable.hidden=Boolean(looxReady||opinewReady||fallback)}function schedule(){if(!frame)frame=requestAnimationFrame(check)}const observer=new MutationObserver(schedule);observer.observe(loox,{childList:true,subtree:true,attributes:true,attributeFilter:['style','height','class']});if(opinew)observer.observe(opinew,{childList:true,subtree:true,attributes:true,attributeFilter:['style','height','class']});panel.addEventListener('load',schedule,true);const timer=setTimeout(()=>{elapsed=true;check()},8000);document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(panel)){observer.disconnect();clearTimeout(timer);cancelAnimationFrame(frame)}})})}d1ReviewPanels();document.addEventListener('shopify:section:load',e=>d1ReviewPanels(e.target));
  } catch(e) { console.error(e); }
})();

})();
